import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginService } from './services/login.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(): boolean {
    console.log('AuthGuard#canActivate called');
    if (this.loginService.IsUserLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/register']);
      return false;
    }
  }

  isAdmin(): boolean {
    return this.loginService.IsValidAdminToken();
  }

  
}
